import { useApplicationState } from '@atlas/core';

export const useAccountBlocked = () => {
  const { account } = useApplicationState();
  const sigapLimitedAt = account?.additionalParameters?.SIGAP_ACCESS_LIMITED_AT;

  return !!sigapLimitedAt;
};
